import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { Activity } from './types';

/**
 * Retrieves paginated activity feed for user
 *
 * @method getActivityFeed
 * @memberof Gamification
 * @param  {number} page - Page number
 * @returns {Promise<Activity[]>} - Activity feed properties
 */

export const getActivityFeed = async (page: number, userOnly: boolean): Promise<Activity[]> => {
  let url;

  if (userOnly) {
    url = `${Constants.BACKEND_URL}/achievements/my-activity-feed/${page}`;
  } else {
    url = `${Constants.BACKEND_URL}/achievements/activity-feed/${page}`;
  }

  return httpGet(url, {})
    .then((response) => {
      const activities: Activity[] = response?.data?.activity_feed;

      return activities;
    })
    .catch((error) => {
      throw Error(error);
    });
};
